<app-form-page [config]="config" [dialogRef]="dialogRef" [drillDown]="false"></app-form-page>
